'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAppLoaded = isAppLoaded;
exports.getApp = getApp;
exports.toggleTutorial = toggleTutorial;

var _Api = require('shared/redux/utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAppLoaded(state) {
  return !!(state.site && state.site.title);
}

function getApp() {
  return {
    type: _types.GET_APP,
    promise: _Api2.default.fetch(_types.GET_APP)
  };
}

function toggleTutorial() {
  return {
    type: _types.TOGGLE_TUTORIAL
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/App/actions.js
// module id = 1144
// module chunks = 0